// extracted by mini-css-extract-plugin
export default {"alfa":"Gabarit_alfa__gl7zG","btadd":"Gabarit_btadd__UQctT","creer":"Gabarit_creer__1qyh1","comtnet":"Gabarit_comtnet__TQnL4","fontSize":"Gabarit_fontSize__YVvgZ"};